<template>
  <confirm-modal
    :show-modal.sync="showModalInternal"
    :title="title"
    @close="onClose"
    @confirm="$emit('confirm')"
    :confirm-button-color="confirmButtonColor"
    :confirm-button-label="confirmButtonLabel"
    hide-cancel-button
    max-width="750"
  >
    <warning-alert
        v-for="(errors, errorKey) in validationErrors"
        :key="errorKey"
        :value="true"
    >
      <div class="pb-2" v-if="errorKey !== ''">
        <b>
          {{ errorKey }}
        </b>
      </div>
      <div>
        <validation-errors-list :error-list="errors"/>
      </div>
    </warning-alert>

  </confirm-modal>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import ConfirmModal from './ConfirmModal';
import WarningAlert from './WarningAlert';
import BookingValidationError from './BookingValidationError';
import ValidationErrorsList from './ValidationErrorsList';

export default {
  name: 'ValidationErrorsModal',
  components: {ValidationErrorsList, WarningAlert, ConfirmModal},
  mixins: [
    LocaleUtils,
  ],
  props: {
    showModal: {},
    validationErrors: {
      type: Object,
      default () {
        return {};
      },
    },
    title: null,
    confirmButtonColor: null,
    confirmButtonLabel: null
  },
  data () {
    return {
      showModalInternal: false,
    }
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  },
  methods: {
    onClose () {
      this.$emit('update:validation-errors', {});
      this.$emit('close');
    }
  }
}
</script>
